module.exports = __webpack_public_path__ + "static/logo_innovatech3v-125b9f71e4df7f087f01eeac117107a9.jpg";